import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Chip } from '@mui/material';

export default function TopBar({user, onLogout}) {

    return (
        <AppBar position="static">
            <Container maxWidth="100%">
                <Toolbar disableGutters>
                <img src="https://atlas-public-assets.s3.eu-west-1.amazonaws.com/canvas.png"
                                                    style={{ maxWidth: "40px", maxHeight: "40px", "borderRadius": "5% 60% 5% 60%" }} />
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} />
                    <Box sx={{ flexGrow: 0 }}>
                        <Chip variant='outlined' label={user?.username || "NO USER"} sx={{mr: 2}}/>
                        <Button size='small' color='error' onClick={onLogout} sx={{mr: 2}}>Logout</Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );


}